<template>
    <BasePanel
        headline="lang_LABEL_TRACKS_CAPTION_CONTRACTS"
        :alvqa="alvqa"
    >
        <template v-slot:panelContent>
            <v-data-table
                :headers="headers"
                :items="listItems"
                hide-default-footer
                :header-props="{ sortIcon: '' }"
                :no-data-text="$t('lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')"
                class="noMinWidth"
            >
            <!-- Headers -->
                <template v-for="(header, i) in headers" v-slot:[`header.${header.value}`]>
                    <span :alvqa="header.alvqa" :key="i">{{ header.text }}</span>
                </template>

            <!-- Items -->
                <template v-slot:[`item.alvId`]="{ item }">
                    <div :alvqa="alvqa + '-list-row-' + item.id + '-text-contract-number'">
                        {{ item.alvId }}
                    </div>
                </template>
                <template v-slot:[`item.licensor`]="{ item }">
                    <div class="ellipsis">
                        <BaseTooltip
                            :simpleText="item.licensor.name"
                            :alvqa="alvqa + '-list-row-' + item.id + '-text-licensor'"
                        />
                    </div>
                </template>
                <template v-slot:[`item.salesType`]="{ item }">
                    <div :alvqa="alvqa + '-list-row-' + item.id + '-text-sales-type'">
                        {{ getSalesType(item.salesType) }}
                    </div>
                </template>
                <template v-slot:[`item.license`]="{ item }">
                    <div :alvqa="alvqa + '-list-row-' + item.id + '-text-license'">
                        {{ getLicence(item.license) }}
                    </div>
                </template>
                <template v-slot:[`item.base`]="{ item }">
                    <div 
                        class="text-right"
                        :alvqa="alvqa + '-list-row-' + item.id + '-text-base'"
                    >
                        {{ $alvPlugin.getNumberLocalization(item.base, 'number') }}
                    </div>
                </template> 
                <template v-slot:[`item.share`]="{ item }">
                    <div 
                        class="text-right"
                        :alvqa="alvqa + '-list-row-' + item.id + '-text-split'"
                    >
                        {{ $alvPlugin.getNumberLocalization(item.share, 'number') }}
                    </div>
                </template>
                <template v-slot:[`item.region`]="{ item }">
                    <div :alvqa="alvqa + '-list-row-' + item.id + '-text-region'">
                        {{ $alvPlugin.createRegionsToString(item.region) }}
                    </div>
                </template>
                <template v-slot:[`item.category`]="{ item }">
                    <div :alvqa="alvqa + '-list-row-' + item.id + '-text-category'">
                        {{ $t(getCategory(item.category)) }}
                    </div>
                </template>
            </v-data-table>
        </template>
    </BasePanel>
</template>

<script>
import BasePanel from '@/components/_base/BasePanel'
import BaseTooltip from '@/components/_base/BaseTooltip'

import 
    { 
        DropdownContractsLabelPriceCategories, 
        DropdownContractsLabelSalesType,
        DropdownContractsLabelLicense
    } 
from '@/assets/dropdowns/alvDropdowns.js'

export default {
    name: "TracksContractsReadOnlyPanel",
    components: {
        BasePanel,
        BaseTooltip
    },
    props: {
        trackAlvId: {
            type: String
        }
    },
    data() {
        return {
            alvqa: 'label-tracks-list-row-' + this.trackAlvId + 'read-only-panel-contracts'
        }
    },
    computed: {
        headers() {
            return [
                {
                    text: this.$t('lang_CONTRACTS_LABEL_CAPTION_CONTRACT_ID'), 
                    align: "left", 
                    value: "alvId",
                    class: 'text-no-wrap',
                    width: "170px",
                    sortable: false,
                    alvqa: this.alvqa + '-header-contract-number'
                },
                {
                    text: this.$t('lang_GENERIC_CONTRACTS_CAPTION_CONTRACTING_PARTY'), 
                    align: "left", 
                    value: "licensor",
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + '-header-licensor'
                },
                {
                    text: this.$t("lang_LABEL_SALES_DATA_CAPTION_SALES_TYPE"),
                    value: "salesType",
                    align: "left",
                    class: 'text-no-wrap',
                    width: '180px',
                    sortable: false,
                    alvqa: this.alvqa + '-header-sales-type'
                },
                {
                    text: this.$t("lang_GENERAL_CAPTION_LICENSE"),
                    value: "license",
                    align: "left",
                    class: 'text-no-wrap',
                    width: '100px',
                    sortable: false,
                    alvqa: this.alvqa + '-header-license'
                },
                {
                    text: this.$t("lang_CONTRACTS_LABEL_EDIT_SPLITS_PANEL_CAPTION_BASE"),
                    value: "base",
                    align: "right",
                    width: '100px',
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + '-header-base'
                },
                {
                    text: this.$t("lang_GENERAL_CAPTION_SPLIT"),
                    value: "share",  
                    align: "right",
                    width: '100px',
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + '-header-shares'
                },
                {
                    text: this.$t("lang_CONTRACTS_PUBLISHING_EDIT_SHARES_PANEL_CAPTION_REGION"),
                    value: "region",
                    align: "left",
                    class: 'text-no-wrap',
                    width: '200px',
                    sortable: false,
                    alvqa: this.alvqa + '-header-region'
                },
                {
                    text: this.$t("lang_LABEL_SALES_DATA_CAPTION_CATEGORY"),
                    value: "category",
                    align: "left",
                    class: 'text-no-wrap',
                    width: '100px',
                    sortable: false,
                    alvqa: this.alvqa + '-header-category'
                }
            ]
        },

        listItems() { 
            let item = this.$store.getters.getExpandedTracks.find(element => {
                return element.alvId === this.trackAlvId
            })

            let contracts = item.contracts === null ? [] : item.contracts
            return contracts
        }
    },
    methods: {
        getSalesType(salesTypeValue) {
           let salesTypeMatch  = DropdownContractsLabelSalesType.find(type => {
               return type.value === salesTypeValue
           })

           if(salesTypeMatch !== undefined) {
               return this.$alvPlugin.isLangConst(salesTypeMatch.text) ? this.$t(salesTypeMatch.text) : salesTypeMatch.text
            }
        },
        getLicence(licenseValue) {
           let licenseMatch = DropdownContractsLabelLicense.find(license => {
               return license.value === licenseValue
           })

           if(licenseMatch !== undefined)
                return this.$alvPlugin.isLangConst(licenseMatch.text) ? this.$t(licenseMatch.text) : licenseMatch.text
           else return ''
        },
        getCategory(categoryValue) {
            return DropdownContractsLabelPriceCategories.find(category => {
                return category.value = categoryValue
            }).text
        },
    }
}
</script>


<style>
    .noMinWidth table {
        min-width: 0px !important;
        table-layout: fixed;
    }
</style>